import React, { useContext } from 'react'
import GoogleAuth from './googleAuth'
import { AppContext } from '../../context/app'
// import AppleAuth from './appleAuth'
// import FacebookAuth from './facebookAuth'
// import XAuth from './xAuth'

const SocialAuth = ({
  textColor = '#dcdcdc',
  borderColor = '#dddddd',
  isModal = false,
  signInText = 'Or sign in with',
  paddingClass = 'pb-4 xl:pb-10',
}) => {
  const { accountObj } = useContext(AppContext)

  const isSocialLoginAllowed = accountObj?.od_resource_allowances?.is_social_login_allowed

  return (
    <div
      style={{ display: isSocialLoginAllowed ? 'block' : 'none' }}
      className={`mt-4 w-full ${isModal ? '' : paddingClass} `}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{ flex: 1, height: '1px', backgroundColor: `${textColor}70` }}></div>
        <span style={{ color: textColor, fontSize: '14px', fontWeight: '500' }}>
          {isModal ? signInText : 'OR'}
        </span>
        <div style={{ flex: 1, height: '1px', backgroundColor: `${textColor}70` }}></div>
      </div>
      {isModal ? (
        <div className="mt-5 flex justify-center items-center">
          <GoogleAuth textColor={textColor} borderColor={borderColor} isModal />
        </div>
      ) : (
        <>
          <div className={`mt-4 w-full`}>
            <GoogleAuth textColor={textColor} borderColor={borderColor} />
          </div>
          {/* <div className="mt-4 w-full">
        <AppleAuth />
      </div>
      <div className="mt-4 w-full">
        <FacebookAuth />
      </div> 
      <div className="mt-4 w-full">
        <XAuth />
      </div> */}
        </>
      )}
    </div>
  )
}

export default SocialAuth
